import { differenceInCalendarDays, format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export type PeriodoStatus = 'agendado' | 'em-andamento' | 'encerrado'

/** Dias corridos do período, contando o primeiro e o último dia. */
export function diasCorridos(inicio: string, fim: string): number {
  return differenceInCalendarDays(parseISO(fim), parseISO(inicio)) + 1
}

/** Situação em relação a `hoje` (`yyyy-MM-dd`); comparação lexicográfica é segura nesse formato. */
export function periodoStatus(
  inicio: string,
  fim: string,
  hoje = format(new Date(), 'yyyy-MM-dd'),
): PeriodoStatus {
  if (hoje < inicio) return 'agendado'
  if (hoje > fim) return 'encerrado'
  return 'em-andamento'
}

/**
 * Período por extenso, sem repetir mês/ano iguais:
 * `22 de set de 2026`, `22 a 24 de set de 2026`, `29 de set a 2 de out de 2026`,
 * `30 de dez de 2026 a 2 de jan de 2027`.
 */
export function formatPeriodo(inicio: string, fim: string): string {
  const inicioDate = parseISO(inicio)
  const fimDate = parseISO(fim)
  const fmt = (date: Date, pattern: string) => format(date, pattern, { locale: ptBR })
  const fimLabel = fmt(fimDate, "d 'de' MMM 'de' yyyy")
  if (inicio === fim) return fimLabel

  const inicioPattern =
    inicioDate.getFullYear() !== fimDate.getFullYear()
      ? "d 'de' MMM 'de' yyyy"
      : inicioDate.getMonth() !== fimDate.getMonth()
        ? "d 'de' MMM"
        : 'd'
  return `${fmt(inicioDate, inicioPattern)} a ${fimLabel}`
}
